<template>
  <div class="opera-guide">
    <div
      class="opera-guide-header opera-guide-bg"
      :style="{
        height: step.top + 'px',
      }"
    />
    <div class="opera-guide-content flex-center-center">
      <div
        class="opera-guide-content-left opera-guide-bg"
        :style="{
          width: step.left + 'px',
        }"
      />
      <div
        class="opera-guide-content-middle"
        :style="{
          height: step.height + 'px',
          width: step.width + 'px',
          borderRadius: step.borderRadius,
        }"
      />
      <div class="opera-guide-content-right opera-guide-bg" />
    </div>
    <div class="opera-guide-footer opera-guide-bg" />

    <div
      class="guide-area-wrap"
      :style="{ top: `${step.top + step.height - 12}` + 'px' }"
    >
      <div>
        <div
          class="point-area"
          :style="{ height: step.showHand ? '160px' : '55px' }"
        >
          <img
            v-if="step.showHand"
            class="point-hand-icon"
            :class="step.pointPosition || 'center'"
            src="/assets/img/chargingVoucher/icon-hand.png"
          >
          <div
            class="point-line"
            :class="step.pointPosition || 'center'"
          />
        </div>
        <div class="guide-area flex-center-center">
          {{ step.text }}
        </div>
        <div class="btns">
          <div
            class="btn"
            v-if="curStep === steps.length - 1"
            @click="() => guideEnd()"
          >
            知道了
          </div>
          <template v-else>
            <div
              class="btn"
              @click="() => guideEnd()"
            > 跳过指引 </div>
            <div
              class="btn"
              @click="() => handleNextStep()"
            >
              下一步
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperaGuide',
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      curStep: 0
    };
  },
  computed: {
    step() {
      return this.steps[this.curStep];
    }
  },
  methods: {
    nextStep() {
      this.curStep++;
    },
    handleNextStep() {
      this.nextStep();
      this.$emit('nextStep', this.step);
    },
    guideEnd() {
      this.$emit('guideEnd');
    }
  }
};
</script>

<style lang="scss" scoped>
.opera-guide {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;

  .opera-guide-bg {
    opacity: 0.6;
    background: #000000;
  }
  .opera-guide-content {
    .opera-guide-content-left {
      height: 100%;
    }
    .opera-guide-content-middle {
      overflow: hidden;
      position: relative;
      z-index: 2;
      box-shadow: 0 0 0 10px #ffffff;
    }
    .opera-guide-content-right {
      flex: 1;
      height: 100%;
    }
  }
  .opera-guide-footer {
    flex: 1;
  }
  .guide-area-wrap {
    position: absolute;
    width: 100vw;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .guide-area {
      background: #fe7256;
      border-radius: 20px;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      height: 120px;
      padding: 36px 24px;
      width: max-content;
      box-sizing: border-box;
      min-width: 620px;
    }
  }
  .btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-top: 72px;

    .btn {
      background: #ffffff;
      border-radius: 36px;
      font-size: 32px;
      color: #ff722c;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 14px 26px;
      line-height: 45px;
      margin-right: 48px;
      min-width: 180px;
      box-sizing: border-box;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .point-area {
    width: 100%;
    position: relative;

    .point-hand-icon {
      height: 80px;
      width: 160px;
      position: absolute;
      left: 50%;
      bottom: 80px;
      z-index: 1;
      transform: translateX(-135px);
      object-fit: contain;

      &.left {
        left: 25%;
      }
      &.center {
        left: 50%;
      }
      &.right {
        left: 75%;
      }
    }
    .point-line {
      height: 55px;
      width: 4px;
      background-color: #fe7256;
      position: absolute;
      left: 50%;
      bottom: 0;
      z-index: 1;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;

      &.left {
        left: 25%;
      }
      &.center {
        left: 50%;
      }
      &.right {
        left: 75%;
      }
      &::before {
        content: "";
        display: block;
        width: 14px;
        height: 14px;
        border: 6px solid #fe7256;
        border-radius: 50%;
        background: #ffffff;
        position: absolute;
        top: 0;
        transform: translateY(-50%);
      }
      &::after {
        content: "";
        display: block;
        overflow: hidden;
        border-top: 20px solid #fe7256;
        border-left: 20px solid #fe7256;
        background: #fe7256;
        position: absolute;
        bottom: 0;
        transform: translateY(50%) rotate(45deg);
      }
    }
  }
}
.flex-center-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
